import { render } from "./LocationAdd.vue?vue&type=template&id=5707bbe0&scoped=true"
import script from "./LocationAdd.vue?vue&type=script&lang=js"
export * from "./LocationAdd.vue?vue&type=script&lang=js"

import "./LocationAdd.vue?vue&type=style&index=0&id=5707bbe0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5707bbe0"]])

export default __exports__